import { render, staticRenderFns } from "./IngredientAisleView.vue?vue&type=template&id=6263b3ef"
import script from "./IngredientAisleView.vue?vue&type=script&lang=js"
export * from "./IngredientAisleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports